"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var dyna_interfaces_1 = require("dyna-interfaces");
var envGlobal_1 = require("../utils/envGlobal");
var DynaNodeLocalInstanceConnection = /** @class */ (function () {
    function DynaNodeLocalInstanceConnection(_config) {
        var _this = this;
        this._config = _config;
        this._handleInputMessage = function (message) {
            message._addTrace('DynaNode/ClientInstanceConnection/RECEIVE_001', "DynaNode: Local Instance Connection, incoming message from server " + _this._config.serverAddress);
            _this._config.onMessage(message);
        };
    }
    DynaNodeLocalInstanceConnection.prototype.connect = function () {
        this._bridge = envGlobal_1.envGlobal[encodeURI("_dnsic_" + this._config.serverAddress)];
        if (!this._bridge) {
            return Promise.reject({
                section: 'DynaNodeLocalInstanceConnection',
                code: 1809301616,
                message: "Local instance dyna node server [" + this._config.serverAddress + "] doesn't exist",
            });
        }
        // register to the bridge
        var _a = this._bridge.register({
            onReceive: this._handleInputMessage,
        }), send = _a.send, unregister = _a.unregister;
        this._bridgeSend = send.bind(this);
        this._bridgeUnregister = unregister;
        return Promise.resolve();
    };
    Object.defineProperty(DynaNodeLocalInstanceConnection.prototype, "serverAddress", {
        get: function () {
            return this._config.serverAddress;
        },
        enumerable: true,
        configurable: true
    });
    DynaNodeLocalInstanceConnection.prototype.send = function (message, compress) {
        if (compress === void 0) { compress = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                compress; // for TS fix, on Local instance we don't use this flag
                if (this._bridge && this._bridgeSend) {
                    message._addTrace('DynaNode/ClientLocalInstanceConnection/SEND_003/004', "DynaNode: DynaNodeClient Local Instance connection pushing message to other local instance connection");
                    this._bridgeSend(message);
                    return [2 /*return*/, message];
                }
                else {
                    throw {
                        code: 1809301212,
                        errorType: dyna_interfaces_1.EErrorType.USER,
                        message: "DynaNodeServerInstanceConnection: Cannot find local instance server " + this._config.serverAddress,
                    };
                }
                return [2 /*return*/];
            });
        });
    };
    DynaNodeLocalInstanceConnection.prototype.disconnect = function () {
        if (!this._bridge)
            return Promise.resolve();
        if (this._bridgeUnregister)
            this._bridgeUnregister();
        this._bridge = undefined;
        this._bridgeSend = undefined;
        this._bridgeUnregister = undefined;
        return Promise.resolve();
    };
    DynaNodeLocalInstanceConnection.prototype._debug_dropConnection = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.disconnect()];
                    case 1:
                        _a.sent();
                        this._config.onConnectionClose("*violent*disconnect*");
                        return [2 /*return*/];
                }
            });
        });
    };
    return DynaNodeLocalInstanceConnection;
}());
exports.DynaNodeLocalInstanceConnection = DynaNodeLocalInstanceConnection;
//# sourceMappingURL=DynaNodeLocalInstanceConnection.js.map